import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font-provider.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/SFPro-Display-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/SFPro-Display-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/SFPro-Display-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/SFPro-Display-Heavy.woff2%22,%22weight%22:%22900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--sfpro-display%22}],%22variableName%22:%22SFProDisplay%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'SFProDisplay', 'SFProDisplay Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
